module.exports = __webpack_public_path__ + "img/home_hover_story_card3.ac71d276.svg";